module.exports = __webpack_public_path__ + "static/media/close-pink.82f1c8e0.svg";